module.exports = __webpack_public_path__ + "img/translated_captions.e577189c.svg";